import React from 'react';

/**
 * PageHeader Component
 *
 * Unified header component for all main pages (Appointments, Pipeline, Quotes, Templates, Clients)
 * Designed to be placed INSIDE the main content box as the top section.
 *
 * @param {string} title - The main page title (displayed in blue)
 * @param {React.ReactNode} children - Action buttons to display on the right (desktop) or below (mobile)
 * @param {string} className - Optional additional CSS classes for the container
 */
function PageHeader({ title, children, className = '' }) {
  return (
    <div className={`pb-6 border-b border-gray-200 ${className}`}>
      {/* Desktop: Title left, Buttons right | Mobile: Title top, Buttons full width below */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        {/* Title - Always blue */}
        <h1 className="text-3xl font-bold text-primary-600">
          {title}
        </h1>

        {/* Action Buttons - Responsive layout */}
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          {children}
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
